module.exports = __webpack_public_path__ + "img/w.7afa2aed.png";